import { computed } from "vue";
import Settings from "@/stores/Settings";

/**
 * Réglages de la façon de travailler, dans le volet Paramètres de l'outil
 * dessin (ex-paramètres généraux de l'app) : dessin au stylet uniquement et
 * sauvegarde automatique. Chacun garde son store, sa persistance et son suivi.
 */
export function useWorkSettings() {
  const stylusOnly = computed({
    get: () => Settings.onlyStylusOn,
    set: (on: boolean) => {
      if (on !== Settings.onlyStylusOn) Settings.setStylusMode(on);
    },
  });

  const autoSave = computed({
    get: () => Settings.autoSaveOn,
    set: (on: boolean) => {
      if (on !== Settings.autoSaveOn) Settings.setAutoSaveMode(on);
    },
  });

  return { stylusOnly, autoSave };
}
